/**
 * Returns Tailwind classes for score badge styling based on score value.
 * Used for deal/recommendation scores and due diligence scores.
 */
export function getScoreBadgeClass(score: number): string {
  if (score >= 80) return "border-green-500 text-green-600";
  if (score >= 40) return "border-amber-500 text-amber-600";
  return "border-red-500 text-red-600";
}
